import React from 'react';
import { CheckCircle2, UserCheck, GraduationCap } from 'lucide-react';
export function BenefitsSection() {
  return <section className="bg-white py-16 md:py-24" data-id="element-1">
      <div className="mx-auto max-w-5xl px-4" data-id="element-2">
        <div className="grid gap-12 md:grid-cols-2" data-id="element-3">
          {/* Students Benefits */}
          <div className="rounded-2xl bg-green-50 p-8 md:p-10 border border-green-100" data-id="element-4">
            <div className="mb-6 flex items-center gap-4" data-id="element-5">
              <div className="flex h-12 w-12 items-center justify-center rounded-full bg-green-100 text-green-600" data-id="element-6">
                <GraduationCap className="h-6 w-6" data-id="element-7" />
              </div>
              <h3 className="text-2xl font-bold text-gray-900" data-id="element-8">
                ¿Qué logran tus alumnos?
              </h3>
            </div>
            <ul className="space-y-4" data-id="element-9">
              {['Más atención y foco', 'Menos conflictos innecesarios', 'Mejor clima emocional', 'Mayor participación', 'Clases más claras y ordenadas'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-10">
                  <CheckCircle2 className="mt-0.5 h-5 w-5 shrink-0 text-green-600" data-id="element-11" />
                  <span className="text-lg text-gray-800" data-id="element-12">{item}</span>
                </li>)}
            </ul>
          </div>

          {/* Teacher Benefits */}
          <div className="rounded-2xl bg-blue-50 p-8 md:p-10 border border-blue-100" data-id="element-13">
            <div className="mb-6 flex items-center gap-4" data-id="element-14">
              <div className="flex h-12 w-12 items-center justify-center rounded-full bg-blue-100 text-blue-600" data-id="element-15">
                <UserCheck className="h-6 w-6" data-id="element-16" />
              </div>
              <h3 className="text-2xl font-bold text-gray-900" data-id="element-17">
                ¿Qué ganás vos como docente?
              </h3>
            </div>
            <ul className="space-y-4" data-id="element-18">
              {['Dejar de improvisar', 'Saber exactamente qué decir', 'Intervenir sin desgastarte', 'Recuperar autoridad sin gritar', 'Sentirte más seguro en el aula', 'Volver a casa con menos carga mental'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-19">
                  <CheckCircle2 className="mt-0.5 h-5 w-5 shrink-0 text-blue-600" data-id="element-20" />
                  <span className="text-lg text-gray-800" data-id="element-21">{item}</span>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}